export const FlexiLoanIcon = () => {
  return (
    <svg
      width="36"
      height="35"
      viewBox="0 0 36 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.8125 29.1645C19.1852 29.1645 30.0287 18.321 30.0287 4.94824"
        stroke="#08172B"
        strokeWidth="3.02703"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M1.48828 29.5471C1.48828 30.3367 1.80196 31.094 2.3603 31.6523C2.91865 32.2107 3.67593 32.5244 4.46555 32.5244C5.25517 32.5244 6.01245 32.2107 6.5708 31.6523C7.12915 31.094 7.44282 30.3367 7.44282 29.5471C7.44282 28.7575 7.12915 28.0002 6.5708 27.4418C6.01245 26.8835 5.25517 26.5698 4.46555 26.5698C3.67593 26.5698 2.91865 26.8835 2.3603 27.4418C1.80196 28.0002 1.48828 28.7575 1.48828 29.5471Z"
        fill="#EEF4F7"
        stroke="#FB5950"
        strokeWidth="2.97727"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.1357 5.47461L30.1217 1.48867L34.1076 5.47461"
        stroke="#08172B"
        strokeWidth="2.97727"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
